module.exports = __webpack_public_path__ + "static/media/nr.61a42463.svg";